import React from 'react'
import { CellCompProps } from 'src/components/Table/Table'
import ToggleSwitch from 'src/components/ToggleSwitch/ToggleSwitch'
import { Asset } from 'src/types'

const AccessCell = <T extends Asset> ({ row, col }: CellCompProps<T>) => {
  const isEnabled = col.enabled?.has(row[col.idField])
  const isForced = col.forceEnabled?.has(row[col.idField])
  const handleChange = v => col.onChange && col.onChange(row[col.idField], v)

  return (
    <div className={`cell ${col.name}`}>
      <ToggleSwitch
        value={isEnabled || isForced}
        disabled={isForced}
        onChange={handleChange}
      />
    </div>
  )
}

export default AccessCell
